import * as React from 'react';

import type { EmployeeAccountVM } from 'ab-viewModels/toolRepair/preview.viewModel';

import * as UserUtils from '@acceligentllc/shared/utils/user';

import styles from './styles.module.scss';

interface OwnProps {
	label: string;
	employee: Nullable<EmployeeAccountVM>;
}

type Props = OwnProps;

const EmployeeData: React.FC<Props> = (props) => {
	const { label, employee } = props;

	const fullName = employee ? UserUtils.getUserName(employee) : null;

	return (
		<>
			<div className={styles['grey-text']}>{label}</div>
			<div className={styles['field-value']}>{fullName ?? 'N/A'}</div>
		</>
	);
};

export default EmployeeData;
